import styles from "../../styles/DataPolicyCheck.module.scss";

interface Props {
  dataPolicyLink: string;
  dataUsageLink: string;
}

export const DataPolicyCheck = (props: Props) => {
  const { dataPolicyLink, dataUsageLink } = props;

  if (!dataPolicyLink || !dataUsageLink) {
    return null;
  }

  return (
    <div className={styles.formItem}>
      <input
        type="checkbox"
        required={true}
        name="check"
        value="check"
        defaultChecked
      />
      <label>
        Autoriza el uso de información para las finalidades indicadas en la
        siguiente política de
        <a href={dataPolicyLink} target="_blank" rel="noreferrer">
          tratamiento de datos
        </a>
        y el manejo de datos de acuerdo a lo indicado en la
        <a href={dataUsageLink} target="_blank" rel="noreferrer">
          política de uso de información.
        </a>
      </label>
    </div>
  );
};
